import { Text, View } from "@react-pdf/renderer";
import { styles } from "../styles";

export function RangeView({ sharedOptions }) {
  return (
    <View>
      <Text style={styles.title}>{"PERÍODO DO RELATÓRIO"}</Text>
      <Text style={styles.text}>
        {"Data Inicial: " +
          sharedOptions?.dataInicial +
          " " +
          sharedOptions?.horaInicial}
      </Text>
      <Text style={styles.text}>
        {"Data Final: " +
          sharedOptions?.dataFinal +
          " " +
          sharedOptions?.horaFinal}
      </Text>
    </View>
  );
}
